import { ReactNode } from 'react';
import { Permission, useGuard, useGuardAny } from '@/hooks/useGuard';

type NamedChildren = { success: ReactNode; fallback: ReactNode };

interface AccessGuardProps {
    permission: Permission;
    children: ReactNode | NamedChildren;
}

function isNamedChildren(nodes: ReactNode | NamedChildren): nodes is NamedChildren {
    return typeof nodes === 'object' && nodes !== null && 'success' in nodes;
}

export const AccessGuard = ({ permission, children }: AccessGuardProps) => {
    const hasAccess = useGuard(permission);
    const { success, fallback } = isNamedChildren(children) ? children : { success: children, fallback: null };
    if (!hasAccess) {
        return fallback;
    }
    return <>{success}</>;
};

interface AccessGuardAnyProps {
    permissions: Permission[];
    children: ReactNode | NamedChildren;
}

export const AccessGuardAny = ({ permissions, children }: AccessGuardAnyProps) => {
    const hasAccess = useGuardAny(permissions);
    const { success, fallback } = isNamedChildren(children) ? children : { success: children, fallback: null };
    if (!hasAccess) {
        return fallback;
    }
    return <>{success}</>;
};
